import { debounce } from '@theme/utilities';

/**
 * Measures the widest button block's rendered width and exposes it as a CSS variable.
 * Whether it actually applies is decided in CSS via a `:has()` selector (see image-text-card.liquid) —
 * this only ever supplies the value, since measuring rendered text width isn't possible in CSS alone.
 */
class ImageTextCardContent extends HTMLElement {
  connectedCallback() {
    this.#matchButtonWidths();
    this.#resizeListener = debounce(() => this.#matchButtonWidths(), 100);
    window.addEventListener('resize', this.#resizeListener);
    document.fonts?.ready?.then(() => this.#matchButtonWidths());
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.#resizeListener);
  }

  /** @type {() => void} */
  #resizeListener;

  #matchButtonWidths() {
    const buttons = /** @type {HTMLElement[]} */ (
      Array.from(this.querySelectorAll(':scope > .button, :scope > .button-secondary'))
    );

    // Reset first so remeasuring starts from each button's natural width, not a previous match.
    this.style.removeProperty('--image-text-card-button-width');

    if (buttons.length < 2) return;

    const maxWidth = Math.max(...buttons.map((button) => button.offsetWidth));
    this.style.setProperty('--image-text-card-button-width', `${maxWidth}px`);
  }
}

if (!customElements.get('image-text-card-content')) {
  customElements.define('image-text-card-content', ImageTextCardContent);
}
